var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      staticClass: "international",
      attrs: { trigger: "click" },
      on: { command: _vm.clickOptionsTranslate },
    },
    [
      _c("div", [
        _vm._v(
          " " +
            _vm._s(
              _vm.isTranslate == "1" ? _vm.$t("跟随系统") : _vm.$t("原文本")
            ) +
            " "
        ),
      ]),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.isTranslate === "1", command: "1" } },
            [_vm._v(_vm._s(_vm.$t("跟随系统")))]
          ),
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.isTranslate === "0", command: "0" } },
            [_vm._v(_vm._s(_vm.$t("原文本")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }